













import { Page } from '@/core/components/controls';
import { Component, Prop } from 'vue-property-decorator';
import { latLng, LatLng } from 'leaflet';
import { getTableCaption } from '@/core/components/table';
import { StocksMapPageArgs, StocksMapMarker } from './types';
import Map from '@/core/components/map';

@Component({
    components: {
        Map
    },
})
export default class StockMapPage extends Page {
    @Prop({ default: () => ({}) }) public args!: StocksMapPageArgs;

    public markers: StocksMapMarker[] = [];
    public center: LatLng = latLng(0, 0);

    public get pageName(): string {
        return getTableCaption('stocks-map-page');
    }

    public async mounted() {
        const _center = { count: 0, sumLatitude: 0, sumLongitude: 0 };

        this.args.stocksMapItems?.forEach((v) => {
            _center.count += 1;
            _center.sumLatitude += v.latitude;
            _center.sumLongitude += v.longitude;

            const coord = latLng(v.latitude, v.longitude);

            const marker = this.markers.find(x => x.latLng.lat === coord.lat && x.latLng.lng === coord.lng);

            if (marker === undefined) {
                this.markers.push({
                    latLng: coord,
                    info: [v.siteName]
                });
            } else {
                const info = marker?.info || [];
                info.push(v.siteName);
            }
        });
        this.center = latLng(_center.sumLatitude / _center.count, _center.sumLongitude / _center.count);
    }
}
